<form class="form" [formGroup]="form" (ngSubmit)="submit()">
  <div class="profile-form__identity">
    <crm-avatar-field
      [displayUrl]="avatarUrl()"
      [name]="fullName()"
      [canReset]="canReset()"
      [canDelete]="canDelete()"
      (picked)="onAvatarPicked($event)"
      (revert)="onAvatarReset()"
      (deleted)="onAvatarDeleted()"
    />
    @if (avatarError(); as error) {
      <small class="field__error">{{ error | translate }}</small>
    }
    <p class="profile-form__email">{{ email() }}</p>
  </div>

  <div class="form__fields">
    <div class="field">
      <label for="profile-firstName" class="field__label">{{ 'profile.label.firstName' | translate }}</label>
      <input
        pInputText
        id="profile-firstName"
        type="text"
        pSize="large"
        formControlName="firstName"
        class="field__input"
        autocomplete="given-name"
        [placeholder]="'profile.placeholder.firstName' | translate"
        [invalid]="firstNameHasError()"
      />
      @if (firstNameHasError()) {
        <small class="field__error">{{ 'validation.required' | translate }}</small>
      }
    </div>

    <div class="field">
      <label for="profile-lastName" class="field__label">{{ 'profile.label.lastName' | translate }}</label>
      <input
        pInputText
        id="profile-lastName"
        type="text"
        pSize="large"
        formControlName="lastName"
        class="field__input"
        autocomplete="family-name"
        [placeholder]="'profile.placeholder.lastName' | translate"
        [invalid]="lastNameHasError()"
      />
      @if (lastNameHasError()) {
        <small class="field__error">{{ 'validation.required' | translate }}</small>
      }
    </div>

    <div class="field">
      <span class="field__label">{{ 'profile.label.phone' | translate }}</span>
      <crm-phone-input
        formControlName="phone"
        [invalid]="phoneHasError()"
        [placeholder]="'profile.placeholder.phone' | translate"
      />
      @if (phoneHasError() && form.controls.phone.errors?.['invalidPhone']) {
        <small class="field__error">{{ 'profile.error.invalidPhone' | translate }}</small>
      }
    </div>

    <div class="field">
      <label for="profile-language" class="field__label">{{ 'profile.label.language' | translate }}</label>
      <p-select
        inputId="profile-language"
        formControlName="language"
        size="large"
        [options]="languageOptions"
        optionLabel="labelKey"
        optionValue="value"
        [fluid]="true"
        appendTo="body"
      >
        <ng-template let-option pTemplate="selectedItem">
          {{ option.labelKey | translate }}
        </ng-template>
        <ng-template let-option pTemplate="item">
          {{ option.labelKey | translate }}
        </ng-template>
      </p-select>
    </div>
  </div>

  <p-button
    type="button"
    severity="contrast"
    size="large"
    [outlined]="true"
    [fluid]="true"
    [label]="'profile.changePassword.action' | translate"
    (onClick)="openChangePassword()"
  />
</form>

<ng-template #footerTpl>
  <p-button
    type="button"
    severity="contrast"
    size="large"
    [outlined]="true"
    [label]="'common.cancel' | translate"
    [disabled]="isSaving()"
    (onClick)="cancel()"
  />
  <p-button
    type="button"
    severity="contrast"
    size="large"
    [label]="'common.save' | translate"
    [loading]="isSaving()"
    [disabled]="isSaving()"
    (onClick)="submit()"
  />
</ng-template>
